import React from 'react';

// Este componente recebe o plano selecionado (plan) e uma função para o fechar (onClose)
const PlanDetailsModal = ({ plan, onClose }) => {
  // Se não houver plano selecionado, o modal não é renderizado.
  if (!plan) return null;

  return (
    // Fundo escuro semi-transparente que cobre a tela inteira
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex justify-center items-center p-4 transition-opacity duration-300">
      
      {/* Container do modal */}
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] flex flex-col transform transition-all duration-300 scale-95 opacity-0 animate-fade-in-scale">
        
        {/* Cabeçalho do Modal */}
        <div className="flex justify-between items-center p-5 border-b">
          <h3 className="text-xl font-bold text-gray-800">{plan.plan_name}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-800 transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
          </button>
        </div>

        {/* Corpo do Modal com a lista de hospitais */}
        <div className="p-6 overflow-y-auto">
          <h4 className="text-lg font-semibold text-gray-700 mb-4">Hospitais Atendidos:</h4>
          {plan.hospitals && plan.hospitals.length > 0 ? (
            <ul className="space-y-3">
              {plan.hospitals.map(hospital => (
                // Garante que apenas hospitais com nome sejam listados
                hospital.name && (
                  <li key={hospital.id} className="p-4 bg-gray-50 rounded-md border border-gray-200">
                    <p className="font-semibold text-gray-900">{hospital.name}</p>
                    <p className="text-sm text-gray-600 mt-1">{hospital.adress}</p>
                  </li>
                )
              ))}
            </ul>
          ) : (
            <p className="text-gray-600">Não há informações de hospitais para este plano.</p>
          )}
        </div>

        {/* Rodapé do Modal */}
        <div className="p-4 bg-gray-50 border-t text-right">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700 transition"
          >
            Fechar
          </button>
        </div>
      </div>
      
      {/* Adiciona a animação ao CSS global ou num ficheiro de estilos */}
      <style jsx global>{`
        @keyframes fade-in-scale {
          from {
            transform: scale(0.95);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }
        .animate-fade-in-scale {
          animation: fade-in-scale 0.3s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default PlanDetailsModal;
